import React, { Fragment, useEffect } from 'react';
import { Grid, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SnackBar } from 'src/components/SnackBar';
import { Helmet } from 'react-helmet-async';
import CustomerView from './ClientView';

const Customers = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (Object.keys(user).length === 0) {
      navigate('/');
    }
  }, [navigate]);

  return (
    <Fragment>
      <Helmet>
        <title>Clients</title>
      </Helmet>
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <CustomerView />
          </Grid>
        </Grid>
        <SnackBar />
      </Container>
    </Fragment>
  );
};

export default Customers;
